import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { orderProducts, profile } from '../../../modules/customer';

const hasHardwareProducts = (type) => ["equipment", "receiver"].includes(type);

const ShippingSelector = ({ item, id, selectedProduct: { type }, action, shouldSkipShippingOrder }) => <div className="text-right shipping-selector">
    {hasHardwareProducts(type) && <div>
        <form>
            <label>
                <input type="radio" name="shipping" onChange={(e) => action(false)} checked={!shouldSkipShippingOrder} />
                &nbsp; Sendes med post
            </label> &nbsp;
            <label>
                <input type="radio" name="shipping" onChange={(e) => action(true)} checked={shouldSkipShippingOrder} />
                &nbsp; Utlevert
            </label>
        </form>
        {shouldSkipShippingOrder && <span></span>}
        </div>
    }
</div>

const mapStateToProps = createStructuredSelector({
    id: profile.selectors.getCustomerID,
    selectedProduct: orderProducts.selectors.getSelectedProduct,
    shouldSkipShippingOrder: orderProducts.selectors.shouldSkipShippingOrder
});

const mapDispatchToProps = (dispatch, props) => ({
    action: (flag) => dispatch(orderProducts.actions.setSkipShippingOrder(flag))
});

export default connect(mapStateToProps, mapDispatchToProps)(ShippingSelector);
